<template>
  <b-table
    class="mission-table-component-container"
    head-variant="dark"
    sticky-header
    hover
    striped
    :fields="fields"
    :items="items"
  >
    <template v-slot:cell(date)="data">
      <p>{{ data.value | toDate}}</p>
    </template>

    <template v-slot:cell(type)="data">
      <b>{{ data.item | typeTranslate }}</b>
    </template>

    <template v-slot:cell(product)="data">
      <a @click="productMethod(data.item)">
        {{ data.item.missionTitle || data.value | subString }}
      </a>
    </template>

    <template v-slot:cell(comment)="data">
      <p>{{ data.value | existComment }}</p>
    </template>

    <template v-slot:cell(state)="data">
      <h5>
        <b-badge :variant="missionStateDict[data.value]">
          {{data.value}}
        </b-badge>
      </h5>
    </template>
  </b-table>
</template>

<script>
  export default {
    props: {
      items: Array,
      productMethod: Function,
    },
    data() {
      return {
        fields: [
          { key: "date", label: "日期" },
          { key: "type", label: "任務分類" },
          { key: "product", label: "品項名稱" },
          { key: "comment", label: "備註" },
          { key: "state", label: "任務狀態" },
          { key: "owner", label: "任務提出人" },
          { key: "supervisor", label: "主管簽核" },
        ],
        missionStateDict: {
          delete: "secondary",
          pending: "primary",
          approve: "success",
          turnback: "danger",
        },
      };
    },
    filters: {
      subString: (title) =>
        title.length > 24 ? `${title.substr(0, 24)}...` : title,

      toDate: (timestamp) => {
        const date = new Date(timestamp);
        let Y = date.getFullYear();
        let M = date.getMonth();
        let D = date.getDate();
        let H = date.getHours();
        let min = (Array(2).join("0") + date.getMinutes()).slice(-2);
        return `${Y}/${M + 1}/${D} ${H}:${min}`;
      },

      existComment: (comment) => (comment === "" ? "-" : comment),

      typeTranslate: (item) => {
        const { type, system = "Product" } = item;
        const systemName = system === "Product" ? "產品" : "消息";
        const typeDict = {
          add: `${systemName}上架`,
          edit: `${systemName}資訊修改`,
          del: `${systemName}刪除`,
        };
        return typeDict[type];
      },
    },
  };
</script>
